<script setup>
import { inject } from "vue";
import MIcon from "@/components/m/MIcon.vue";

const ctx = inject("mctx");

const TABS = [
  { label: "Home", icon: "dashboard" },
  { label: "Reviews", icon: "reviews", badge: true },
  { label: "Topics", icon: "topics" },
  // `entities`/`competitors`/`menu` are open-stroke glyphs — filling them on
  // activation garbles the shape, so keep them stroked (just heavier when active).
  { label: "Entities", icon: "entities", strokeOnly: true },
  { label: "Compare", icon: "competitors", strokeOnly: true },
  { label: "More", icon: "menu", action: "more", strokeOnly: true },
];

const onTab = (t) => {
  if (t.action === "more") ctx.openMore();
  else ctx.go(t.label);
};

const isActive = (t) => ctx.tab.value === t.label;
const iconFill = (t) => isActive(t) && !t.strokeOnly;
const iconStroke = (t) => (isActive(t) ? (t.strokeOnly ? 2.3 : 0) : 1.9);
</script>

<template>
  <div class="btm-tabs">
    <button
      v-for="t in TABS"
      :key="t.label"
      class="btm-tab"
      :class="{ on: ctx.tab.value === t.label }"
      :aria-current="ctx.tab.value === t.label ? 'page' : undefined"
      :aria-label="t.label"
      @click="onTab(t)"
    >
      <span v-if="t.badge && ctx.urgent.value" class="badge">{{
        ctx.urgent.value
      }}</span>
      <MIcon
        :name="t.icon"
        :size="22"
        :fill="iconFill(t)"
        :sw="iconStroke(t)"
      />
      <span class="lb">{{ t.label }}</span>
    </button>
  </div>
</template>
